import { Injectable } from '@angular/core';
import { WidgetService } from '../../main/widgets/widget.service';
import { Template, TEMPLATE_TYPE } from '../models/template';
import { WidgetGroup } from '../models/widget';

@Injectable({ providedIn: 'root' })
export class TemplateService {

  constructor(private widgetService: WidgetService) {
  }

  createDefaultTemplate(templateType: string, widgetGroups: WidgetGroup[], subjectTypeName?: string): Template {
    const DEFAULT_ROWS_PER_COLUMN = 5;
    const template = new Template(templateType);
    const widgets = [];
    switch (templateType) {
      case TEMPLATE_TYPE.DASHBOARD:
          widgets.push(this.widgetService.getSubjectCardWidget(101, subjectTypeName + ' Details', subjectTypeName, null, null));
        break;

      case TEMPLATE_TYPE.REFERRALDASHBOARD:
          widgets.push(this.widgetService.getReferralCardWidget(101, 'Referral Details', subjectTypeName, null, null));
          widgets.push(this.widgetService.getSubjectCardWidget(102, subjectTypeName + ' Details', subjectTypeName, null, null));
        break;

      default:
        let xOffset = 0;
        let yOffset = 0;
        let count = 0;
        let colMax = 1;
        let rowMax = 1;
        widgetGroups.forEach((widgetGroup) => {
          count = count + 1;
          rowMax = 1;
          let x: number = xOffset;
          const y: number = yOffset;
          widgetGroup.widgets.forEach((widget) => {
            if (templateType !== TEMPLATE_TYPE.LIST) {
              widget.config.x = x;
              widget.config.y = y;
            }
            widgets.push(widget);
            x = x + widget.config.cols;
            if (widget.config.rows > rowMax) {
              rowMax = widget.config.rows;
            }
          });
          if (x > colMax) {
            colMax = x;
          }
          yOffset = yOffset + rowMax;
          if (count === DEFAULT_ROWS_PER_COLUMN) {
            xOffset = colMax;
            yOffset = 0;
            count = 0;
          }
        });
        break;
    }
    template.layoutData = JSON.stringify(this.widgetService.widgetsToLayoutItems(widgets));
    return template;
  }
}
